export const getTaggableItemsListItemSize = () => 83

export const buildTaggableCreatorsInvitationUrl = (token: string) => {
  return `https://onlyfans.com?rfguesttoken=${token}`
}
